import React from 'react'
import FormRender from '../../../utils/newforms/render/FormRender'
import CharCounterHint from './CharCounterHint'
import SingleSeoImageManager from './SingleSeoImageManager/SingleSeoImageManager'
import SeoSectionShell from './SeoSectionShell'
import { SEO_SOFT_LIMITS } from './defaultSeo'
import './ProductSeoSection.sass'

function ProductSeoSection({ form, setForm, ogImage, setOgImage }) {
  if (!form) return null

  return (
    <SeoSectionShell
      title="SEO та контент товару"
      bodyClassName="ProductSeoSection ProductSeoSection_inSpoiler"
    >
      <div className="ProductSeoSection-StatusRow">
        <div className="ProductSeoSection-StatusField">
          <FormRender sections={[{ fields: ['reviewStatus'] }]} form={form} setForm={setForm} errors={false} />
        </div>
        <div className="ProductSeoSection-StatusField">
          <FormRender sections={[{ fields: ['indexationMode'] }]} form={form} setForm={setForm} errors={false} />
        </div>
      </div>
      <p className="ProductSeoSection-StatusHint">
        Review status — внутрішній статус редактури. Indexation mode: «Автоматично» = правила вітрини; «Не
        індексувати» = ручна заборона. H1 та контент PDP беруться з назви товару та товарних полів.
      </p>

      <section className="ProductSeoSection-Section">
        <p className="ProductSeoSection-SectionTitle">Мета-теги та Open Graph</p>

        <div className="ProductSeoSection-MetaGrid">
          <div className="ProductSeoSection-MetaCol">
            <FormRender sections={[{ fields: ['title'] }]} form={form} setForm={setForm} errors={false} />
            <CharCounterHint
              value={form.title?.value}
              softLimit={SEO_SOFT_LIMITS.title}
              helperText="Якщо порожньо — вітрина згенерує title автоматично"
            />

            <FormRender sections={[{ fields: ['metaDescription'] }]} form={form} setForm={setForm} errors={false} />
            <CharCounterHint
              value={form.metaDescription?.value}
              softLimit={SEO_SOFT_LIMITS.metaDescription}
              helperText="Короткий опис для сніпета пошуку"
            />
          </div>

          <div className="ProductSeoSection-MetaCol">
            <FormRender sections={[{ fields: ['ogTitle'] }]} form={form} setForm={setForm} errors={false} />
            <CharCounterHint
              value={form.ogTitle?.value}
              softLimit={SEO_SOFT_LIMITS.ogTitle}
              helperText="Якщо порожньо — візьметься SEO title"
            />

            <FormRender sections={[{ fields: ['ogDescription'] }]} form={form} setForm={setForm} errors={false} />
            <CharCounterHint
              value={form.ogDescription?.value}
              softLimit={SEO_SOFT_LIMITS.ogDescription}
              helperText="Якщо порожньо — візьметься meta description"
            />
          </div>
        </div>

        <div className="ProductSeoSection-OgImage">
          <p className="ProductSeoSection-SectionTitle">OG image</p>
          <SingleSeoImageManager
            formData={ogImage}
            syncState={setOgImage}
            helperText="Зображення для шарингу в соцмережах. Не змінює системні фото товару."
          />
        </div>
      </section>
    </SeoSectionShell>
  )
}

export default ProductSeoSection
